require('../../bootstrap');

import { createApp } from 'vue';
import BusinessDetails from '../../components/merchant/BussinessDetails/BusinessDetails.vue';


createApp({
    components: {
        BusinessDetails,
    }
}).mount('#business-details')
